import {services} from '@/main';
import Axios from 'axios';
import {nanoid} from 'nanoid'

export default class RestService {

    private createXCorrelationId(): string {
        return "mer-" + nanoid();
    }

    /**
     * Appel get de l'URI relatif path.
     * @param path
     */
    public callGet(path: string): Promise<any> {
        const api: string = services.config.config.$api_url;
        const correlationId = this.createXCorrelationId();
        return Axios.get(api + path, {
            headers: {
                'X-Correlation-Id': correlationId,
            },
        });
    }

    /**
     * Appel POST de l'URI reliatif path
     * @param path
     * @param data Les données du post
     */
    public callPost(path: string, data?: any): Promise<any> {
        const api: string = services.config.config.$api_url;
        const correlationId = this.createXCorrelationId();
        if (typeof data === 'undefined') {
            return Axios.post(api + path, null, {
                headers: {
                    'X-Correlation-Id': correlationId,
                },
            });
        } else {
            return Axios.post(api + path, data, {
                headers: {
                    'X-Correlation-Id': correlationId,
                },
            });
        }
    }

    /**
     * Appel POST de l'URI relatif path en mode transmission des données brutes
     * @param path
     * @param data Les données du post
     */
    public callRawPost(path: string, data?: any): Promise<any> {
        const api: string = services.config.config.$api_url;
        const correlationId = this.createXCorrelationId();
        return Axios.post(api + path,
            data,
            {
                headers: {
                    'Content-Type': 'text/plain',
                    'X-Correlation-Id': correlationId,
                },
            });
    }

    /**
     * Appel PATCH de l'URI relatif path
     * @param path
     * @param data Les données du patch
     */
    public callPatch(path: string, data: any): Promise<any> {
        const api: string = services.config.config.$api_url;
        const correlationId = this.createXCorrelationId();
        return Axios.patch(api + path, data, {
            headers: {
                'X-Correlation-Id': correlationId,
            },
        });
    }

    /**
     * Appel PATCH de l'URI relatif path en mode transmission des données brutes
     * @param path
     * @param data Les données
     * @param contentType Le content type
     */
    public callPatchWithContentType(path: string, data?: any, contentType?: string): Promise<any> {
        const api: string = services.config.config.$api_url;
        const correlationId = this.createXCorrelationId();
        return Axios.patch(api + path,
            data,
            {
                headers: {
                    'Content-Type': contentType,
                    'X-Correlation-Id': correlationId,
                },
            });
    }

    /**
     * Appel PUT de l'URI relatif path
     * @param path
     * @param data Les données du put
     */
    public callPut(path: string, data: any): Promise<any> {
        const api: string = services.config.config.$api_url;
        const correlationId = this.createXCorrelationId();
        return Axios.put(api + path, data, {
            headers: {
                'X-Correlation-Id': correlationId,
            },
        });
    }

    /**
     * Appel PUT de l'URI relatif path en mode transmission des données brutes
     * @param path
     * @param data Les données
     * @param contentType Le content type
     */
    public callPutWithContentType(path: string, data?: any, contentType?: string): Promise<any> {
        const api: string = services.config.config.$api_url;
        const correlationId = this.createXCorrelationId();
        return Axios.put(api + path,
            data,
            {
                headers: {
                    'Content-Type': contentType,
                    'X-Correlation-Id': correlationId,
                },
            });
    }

    /**
     * Appel DELETE de l'URI relatif path
     * @param path
     */
    public callDelete(path: string): Promise<any> {
        const api: string = services.config.config.$api_url;
        const correlationId = this.createXCorrelationId();
        return Axios.delete(api + path, {
            headers: {
                'X-Correlation-Id': correlationId,
            },
        });
    }
}
